import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ConstantService} from "../../services/constant.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
	selector: 'fb-blog-video-popup',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './blog-video-popup.component.html',
	styleUrls: ['./blog-video-popup.component.scss']
})
export class BlogVideoPopupComponent implements OnInit {

	@Input()
	public url: string = '';
	public componentLoaded: boolean = false;
	public safeURL: SafeResourceUrl = '';
	public videoUrl: string = '';
	@Output()
	private closeVideoPopup: EventEmitter<boolean> = new EventEmitter<boolean>();

	private getEmbeddedURL(url: string): string {

		let id: string;

		if (ConstantService.YOUTUBE_VIDEO_REGEX.test(url)) {
			id = url.match(ConstantService.YOUTUBE_VIDEO_REGEX)![1];
			return 'https://www.youtube.com/embed/' + id + '?autoplay=1';
		} else if (ConstantService.VIMEO_VIDEO_REGEX.test(url)) {
			id = url.match(ConstantService.VIMEO_VIDEO_REGEX)![1];
			return 'https://player.vimeo.com/video/' + id + '?autoplay=1';
		} else {
			return '';
		}
	}

	constructor(private _sanitizer: DomSanitizer) {
	}

	ngOnInit(): void {
		this.videoUrl = this.getEmbeddedURL(this.url);
		this.componentLoaded = true;

		this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
	}

	public closeVideo(): void {
		this.closeVideoPopup.emit(false);
	}
}
